import { Capacitor } from '@capacitor/core';
import type { PreloadOptions } from '@capgo/native-audio';
import { NativeAudio } from '@capgo/native-audio';

import { RaygunErrorHandlerService } from './raygun';

const { logError } = RaygunErrorHandlerService();

const preloadNewChatSound = async () => {
  try {
    const config: PreloadOptions = {
      assetId: 'newChatSound',
      assetPath: 'assets/sounds/new_chat.mp3',
      audioChannelNum: 1,
      isUrl: false,
      volume: 1.0,
    };
    const { found } = await NativeAudio.isPreloaded(config);
    if (!found) {
      await NativeAudio.preload(config);
    }
  } catch (error) {
    logError(error, ['preloadNewChatSound']);
  }
};

const preloadNewAlertSound = async () => {
  try {
    const config: PreloadOptions = {
      assetId: 'newAlertSound',
      assetPath: 'assets/sounds/new_alert.mp3',
      audioChannelNum: 1,
      isUrl: false,
      volume: 1.0,
    };
    const { found } = await NativeAudio.isPreloaded(config);
    if (!found) {
      await NativeAudio.preload(config);
    }
  } catch (error) {
    logError(error, ['preloadNewAlertSound']);
  }
};

if (Capacitor.isPluginAvailable('NativeAudio')) {
  preloadNewChatSound();
  preloadNewAlertSound();
}
